import * as React from 'react';
import { SVGProps } from 'react';
import { SvgIcon } from '@mui/material';

export const SvgDonorRecognition = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        viewBox="0 0 24 24"
    >
        <path
            d="M19 22L14 17H4C2.89543 17 2 16.1046 2 15V4C2 2.89543 2.89543 2 4 2H20C21.1046 2 22 2.89543 22 4V15C22 16.1046 21.1046 17 20 17H19V22ZM13.8838 5.5C12.9913 5.5 12.3686 6.16601 11.9961 6.5C11.6236 6.16609 10.9937 5.5 10.1074 5.5C8.59824 5.50001 7.50006 6.51561 7.5 8.26855C7.5 11.0653 11.9919 13.4974 11.9961 13.5C12.043 13.4745 16.4912 11.0503 16.4912 8.26855C16.4912 6.54343 15.393 5.50001 13.8838 5.5Z"
            fill="#73717F"
        />
    </svg>
);

export const DonorRecognitionIcon = ({
    fontSize = 'inherit',
    color = 'inherit',
    ...props
}: React.ComponentProps<typeof SvgIcon>) => (
    <SvgIcon
        {...props}
        color={color}
        component={SvgDonorRecognition}
        fontSize={fontSize}
    />
);
